(() => {
  const root = document.querySelector('.aaf-site-header');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const header = root.querySelector('.header');
  const mobile = root.querySelector('.mobile-menu');
  const groups = [...root.querySelectorAll('.nav-group')];
  const update = () => header.classList.toggle('is-scrolled', window.scrollY > 20);
  update();
  window.addEventListener('scroll', update, {passive:true});
  groups.forEach(group => group.addEventListener('toggle', () => {
    if (group.open) groups.forEach(other => {if (other !== group) other.open = false;});
  }));
  document.addEventListener('click', event => {
    if (!root.contains(event.target)) {
      mobile.open = false;
      groups.forEach(group => group.open = false);
    }
  });
  root.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const current = event.target.closest('.nav-group[open]') || (mobile.open ? mobile : null);
    if (current) {current.open = false; current.querySelector('summary').focus();}
  });
})();
